<template>
  <basic-container id="container">
    <div class="section">
      <div class="title">设备信息</div>
      <div class="content">
        <el-row>
          <el-col :span="12" class="_col">
            <span class="name"> HID： </span>
            <span class="text"> {{ initData.hardwareId }} </span>
          </el-col>
          <el-col :span="12" class="_col"> <span class="name"> UID： </span>
            <span class="text"> {{ initData.sdkUserId }} </span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" class="_col">
            <span class="name"> 渠道来源： </span>
            <span class="text"> {{ initData.sdkChannel }} </span>
          </el-col>
          <el-col :span="12" class="_col"> <span class="name"> MAC： </span>
            <span class="text"> {{ initData.mac }} </span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" class="_col">
            <span class="name"> IP： </span>
            <span class="text">{{ `${initData.ip  || '-'}(${initData.address || '-'})` }} </span>
          </el-col>
          <el-col :span="12" class="_col"> <span class="name"> App 版本号： </span>
            <span class="text"> {{ initData.appVersion }} </span>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="section">
      <div class="title">事件流   </div>
      <div class="content">
        <EventFlow ref="EventFlow" ></EventFlow>
      </div>
    </div>

    <div class="section">
      <div class="title"> 实时质量</div>
      <cloudAppTimeQuality ref="cloudAppTimeQuality" :uid="initData.sdkUserId"></cloudAppTimeQuality>
    </div>

    <div class="section">
      <div class="title"> <div>屏幕分享拉流实时质量<span class="el-icon-refresh-left _btn" @click="renovateFlow"> 刷新</span> </div> </div>
      <cloudAppRealTimeQuality ref="cloudAppRealTimeQuality" :uid="initData.sdkUserId"></cloudAppRealTimeQuality>
    </div>

  </basic-container>
</template>
<script>
import EventFlow from "./components/datailEventFlow"
import cloudAppRealTimeQuality from "./components/cloudAppRealTimeQuality"
import cloudAppTimeQuality from "./components/cloudAppTimeQuality"
import {
  getDwSdkCastRealtimeUsersFact
} from "@/api/rabbit/detail";
export default {
  components: { EventFlow, cloudAppRealTimeQuality ,cloudAppTimeQuality},
  data() {
    return {
      initData: {},
    }
  },
  mounted(){
    this.init()
  },
  watch: {
    '$route.path': {
      handler(val) {
        if (val === '/rabbit/cloud-app') {
         this.renovateFlow()
         this.init()
        }
      },
      deep: true
    },
  },
  methods:{
    renovateFlow(){
      this.$refs['EventFlow']._data.current = 0
      this.$refs['EventFlow']._data.initList =[]
      this.$refs['EventFlow'].init()
      this.$refs['cloudAppTimeQuality'].init()
      this.$refs['cloudAppRealTimeQuality'].getMemberList()
    },
    async init() {
      let params = {
        code: this.$route.query.code,
        sdkUserId: this.$route.query.uid,
        roomId:this.$route.query.roomid,
      }
      if(!params.code) return
      try {
        let { data } = await getDwSdkCastRealtimeUsersFact(params)
        this.initData = data.data
        //如果为空显 '-'
        for (let key in this.initData) {
          if (this.initData[key] == "") {
            this.initData[key] = "-"
          }
        }
      } catch (err) {
        console.log(err)
      }

    }
  }

}


</script>
<style scoped lang="scss">
#container {
  padding: 0px 34px;
  background-color: #fff;
  margin: 8px 0px 100px 29px;
  width: calc(100% - 40px);

}

.section {
  margin-bottom: 45px;
  text-align: left;
  font-family: SourceHanSansSC-regular;

  .title {
    color: #101010 100%;
    font-size: 16px;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    ._btn{
      color: #1372e8;
      cursor: pointer;
      font-size: 14px;
      font-weight: normal;
      padding: 5px 10px;
      border-radius: 5px;
   
    }
  }

  .content {
    margin-top: 21px;
    background-color: #F9F7F7;
    padding: 2px 30px 27px;
    color: #101010;
    font-size: 14px;

    ._col {
      display: flex;
      margin-top: 22px;

      .name {
        width: 160px;
      }
    }
  }
}
/deep/.el-col{
  margin-bottom: -5px;
}
</style>